<template>
  <Modal
    class="cc-modal"
    width="600"
    footer-hide
    v-model="visibility"
    title="实名认证"
  >
    <div class="content" style="position: relative">
      <loading :loading="loading" style="z-index: 11"></loading>
      <div class="section">
        <div class="col">
          <div class="name">姓名：</div>
          <Input
            class="height45"
            v-model="form.name"
            placeholder="请输入姓名"
            style="width: 200px"
            clearable
          />
        </div>
        <div class="col">
          <div class="name">证件类型：</div>
          <Select class="height45" v-model="form.cardType" style="width: 200px">
            <Option
              v-for="item in typeList"
              :key="item.value"
              :value="item.value"
              >{{ item.label }}</Option
            >
          </Select>
        </div>
        <div class="col">
          <div class="name">身份证号码：</div>
          <Input
            class="height45"
            v-model="form.confirmIdCardNumber"
            placeholder="请输入身份证号码"
            style="width: 200px"
            clearable
          />
        </div>
        <div class="col">
          <div class="name">身份证正面照：</div>
          <Upload
            v-if="!form.uplodaPath"
            style="width: 200px"
            type="drag"
            :before-upload="handleBeforeUpload"
            :show-upload-list="false"
            action="/"
          >
            <div class="upload-section">
              <img class="icon" src="@/assets/image/upload-icon.png" />
            </div>
          </Upload>
          <div
            class="icon2"
            :style="{ backgroundImage: 'url(' + form.uplodaPath + ')' }"
            v-else
          >
            <div class="close" @click="delImage">
              <Icon size="28" type="ios-close-circle-outline" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="foot">
      <Button
        :loading="loading"
        @click="onConfirm"
        type="primary"
        style="margin-right: 20px"
        >确定</Button
      >
      <Button @click="onCancel">取消</Button>
    </div>
  </Modal>
</template>
<script>
import { userIdentitySave } from "api/user.js";
import { mapMutations } from "vuex";
import loading from "components/loading.vue";
export default {
  name: "updateCertifiedModal",
  components: {
    loading,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      typeList: [
        {
          value: 0,
          label: "身份证",
        },
        {
          value: 1,
          label: "护照",
        },
      ],
      form: {
        name: "",
        cardType: 0, // 0：身份证 1：护照
        confirmIdCardNumber: "",
        idCardNumber: "",
        file: "",
        uplodaPath: "",
      },
      loading: false,
    };
  },
  computed: {
    visibility: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      },
    },
  },
  methods: {
    ...mapMutations(["MUT_USER_INFO_USERNAME"]),
    onCancel() {
      this.form = this.$options.data().form;
      this.visibility = false;
    },
    async onConfirm() {
      if (!this.form.name) {
        this.$Message.warning("请输入真实姓名！");
        return;
      }
      if (!this.form.confirmIdCardNumber) {
        this.$Message.warning("请输入正确的证件号码！");
        return;
      }
      if (!this.form.file) {
        this.$Message.warning("请上传证件正面图片！");
        return;
      }
      this.loading = true;
      const data = new FormData();
      data.append("file", this.form.file);
      data.append("confirmIdCardNumber", this.form.confirmIdCardNumber);
      data.append("idCardNumber", this.form.confirmIdCardNumber);
      data.append("name", this.form.name);
      data.append("cardType", this.form.cardType);
      try {
        const res = await userIdentitySave(data);
        this.loading = false;
        if (res.code === 200 && res.result) {
          this.MUT_USER_INFO_USERNAME(this.form.name);
          this.$emit("submit-success", (res) => {
            if (res) {
              this.onCancel();
              this.$Message.success("提交成功,等待审核成功！");
            }
          });
        }
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    // 选择图片后处理
    handleBeforeUpload(file) {
      if (
        file.type !== "image/jpeg" &&
        file.type !== "image/png" &&
        file.type !== "image/jpg"
      ) {
        this.$Message.warning("图片要求上传jpg或者png格式或者jpeg格式");
        return false;
      }
      this.form.file = file;
      this.form.uplodaPath = window.URL.createObjectURL(file);
      return false;
    },
    // 删除图片
    delImage() {
      this.form.uplodaPath = "";
      this.form.file = "";
    },
  },
};
</script>
<style lang="less" scoped>
.cc-modal {
  .content {
    height: auto;
    min-height: 100px;
    max-height: 500px;
    overflow: auto;
  }
  .foot {
    border-top: 1px solid #dcdee2;
    padding-top: 16px;
    display: flex;
    justify-content: flex-end;
  }
}
.col {
  margin-left: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 20px;
  .name {
    color: #333333;
    font-size: 16px;
    margin-bottom: 10px;
  }
  .label {
    color: #999999;
  }
}
.upload-section {
  width: 200px;
  height: 122px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  .icon {
    width: 45px;
    height: 35px;
  }
}
.icon2 {
  border: 1px dashed #dcdee2;
  position: relative;
  width: 200px;
  height: 122px;
  background-size: cover;
  background-position: center;
  .close {
    position: absolute;
    right: 5px;
    top: 5px;
    cursor: pointer;
  }
}
</style>

<style lang="less" scoped>
/deep/.height45 {
  .ivu-input {
    height: 45px;
    line-height: 45px;
  }
  .ivu-input-icon {
    line-height: 45px;
  }
  .ivu-input-with-prefix {
    padding-left: 60px;
  }
  .ivu-input-prefix {
    width: 60px;
    padding: 0 10px;
  }
  .ivu-select-selection {
    height: 45px;
  }
  .ivu-select-input {
    height: 45px;
  }
  .ivu-select-selected-value {
    height: 45px;
    line-height: 45px;
  }
  .ivu-select-placeholder {
    height: 45px;
    line-height: 45px;
  }
  .ivu-input-prefix i,
  .ivu-input-suffix i {
    line-height: 45px;
  }
}
</style>
